var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11430",
    "data-name": "Group 11430",
    transform: "translate(-131 -96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    transform: "translate(131 96)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 19,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    transform: "translate(134 105)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    transform: "translate(134 110)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    transform: "translate(140 110)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    transform: "translate(140 105)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    transform: "translate(146 105)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    x2: 20,
    transform: "translate(131.5 100.5)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    x2: 20,
    transform: "translate(131.5 102.5)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.15acd2dde614e4e6c6cf939e172eaaff.svg";
export { ForwardRef as ReactComponent };